import { render, staticRenderFns } from "./PostFieldsView.vue?vue&type=template&id=04a100c2&scoped=true&"
import script from "./PostFieldsView.vue?vue&type=script&lang=ts&"
export * from "./PostFieldsView.vue?vue&type=script&lang=ts&"
import style0 from "./PostFieldsView.vue?vue&type=style&index=0&id=04a100c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a100c2",
  null
  
)

export default component.exports